import moment from 'moment';
import 'moment/dist/locale/nl'

export default {
	methods: {
		dateFormat(date, format = 'DD-MM-YYYY') {
			return this.moment(date).format(format);
		},

		moment(date) {
			return moment(date);
		}
	}
}